module.exports = __webpack_public_path__ + "img/bwb5.svg";